<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeParcelas from "./LinhaDeParcelas/LinhaDeParcelas.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraParcela",
    "update:alteraAdiantamento"
]);

//==================================================================//
//==================== Altera Recebimento ==========================//
//==================================================================//

const alteraParcela = (update)=>{

    emits('update:alteraParcela',update);

};

//==================================================================//
//====================== Altera Adiantamento =======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeParcelas v-for="parcela in props?.dado?.parcelas"
            :key="parcela?.id"
            :dado="props?.dado"
            :parcela="parcela"
            @update:alteraParcela="alteraParcela"
            @update:alteraAdiantamento="alteraAdiantamento"
        ></LinhaDeParcelas>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>